import { put, takeLatest } from "redux-saga/effects";

import {
  requestKPIS,
  requestLeadsKPIDashboardList,
  requestClientsDashboardList,
  requestTopDealsWonList,
  requestleadsPipelineList,
  requestsmartproposalPipelineList,
  requestwinRate,
  requestwinLossReport,
  requestsalesPipelineBysalesRepresentative,
  requestTotalAgreements,
  requestClientSeatsKPIS,
  requestRecentClosedDeal,
} from "../../../services/dashboard";
import {
  fetchdashboardRequest,
  fetchdashboardSuccess,
  fetchdashboardFailure,
  fetchsalesRepresentativeDashboardListRequest,
  fetchsalesRepresentativeDashboardListSuccess,
  fetchsalesRepresentativeDashboardListFailure,
  fetchLeadsKPISDashboardRequest,
  fetchLeadsKPISDashboardSuccess,
  fetchLeadsKPISDashboardFaliure,
  fetchClientDashboardListRequest,
  fetchClientDashboardListSuccess,
  fetchClientDashboardListFailure,
  fetchTopDealsWonRequest,
  fetchTopDealsWonSuccess,
  fetchTopDealsWonFaliure,
  fetchleadsPipelineRequest,
  fetchleadsPipelineSuccess,
  fetchleadsPipelineFailure,
  fetchsmartproposalPipelineRequest,
  fetchsmartproposalPipelineSuccess,
  fetchsmartproposalPipelineFailure,
  fetchRecentClosedDealsRequest,
  fetchRecentClosedDealsSuccess,
  fetchRecentClosedDealsFaliure,
  fetchWinRateRequest,
  fetchWinRateSuccess,
  fetchWinRateFaliure,
  fetchWinLossRequest,
  fetchWinLossSuccess,
  fetchWinLossFaliure,
  fetchtotalAgreementsRequest,
  fetchtotalAgreementsSuccess,
  fetchtotalAgreementsFailure,
  fetchClientSeatsKpisRequest,
  fetchClientSeatsKpisSuccess,
  fetchClientSeatsKpisFailure,
} from "../../reducers/dashboard";

export function* watchDashboardSaga() {
  yield takeLatest(fetchdashboardRequest, dashboardkpis);
  yield takeLatest(
    fetchsalesRepresentativeDashboardListRequest,
    fetchSalesRepresentativeDashboardList
  );
  yield takeLatest(fetchLeadsKPISDashboardRequest, fetchLeadsKPISDashboardList);
  yield takeLatest(fetchClientDashboardListRequest, fetchClientDashboardList);
  yield takeLatest(fetchTopDealsWonRequest, fetchTopDealsWonList);
  yield takeLatest(fetchleadsPipelineRequest, fetchleadsPipeline);
  yield takeLatest(
    fetchsmartproposalPipelineRequest,
    fetchsmartProposalPipeline
  );
  yield takeLatest(fetchRecentClosedDealsRequest, fetchRecentDeals);
  yield takeLatest(fetchWinRateRequest, fetchWinList);
  yield takeLatest(fetchWinLossRequest, fetchWinLossList);
  yield takeLatest(fetchtotalAgreementsRequest, fetchTotalAgreements);
  yield takeLatest(fetchClientSeatsKpisRequest, fetchClientSeatsKpis);
}

function* dashboardkpis({ payload }) {
  try {
    const response = yield requestKPIS(payload);
    yield put(fetchdashboardSuccess(response));
  } catch (error) {
    yield put(fetchdashboardFailure("Failed to get KPIS"));
  }
}

function* fetchSalesRepresentativeDashboardList({ payload }) {
  try {
    const response = yield requestsalesPipelineBysalesRepresentative(payload);
    yield put(fetchsalesRepresentativeDashboardListSuccess(response));
  } catch (error) {
    yield put(
      fetchsalesRepresentativeDashboardListFailure(
        "Failed to get list of Sales Representative Dashboard List"
      )
    );
  }
}

function* fetchLeadsKPISDashboardList({ payload }) {
  try {
    const response = yield requestLeadsKPIDashboardList(payload);
    yield put(fetchLeadsKPISDashboardSuccess(response));
  } catch (error) {
    yield put(
      fetchLeadsKPISDashboardFaliure(
        "Failed to get list Leads KPI Dashboard List"
      )
    );
  }
}

function* fetchClientDashboardList({ payload }) {
  try {
    const response = yield requestClientsDashboardList(payload);
    yield put(fetchClientDashboardListSuccess(response));
  } catch (error) {
    yield put(
      fetchClientDashboardListFailure(
        "Failed to get list Leads KPI Dashboard List"
      )
    );
  }
}

function* fetchTopDealsWonList({ payload }) {
  try {
    const response = yield requestTopDealsWonList(payload);
    yield put(fetchTopDealsWonSuccess(response));
  } catch (error) {
    yield put(fetchTopDealsWonFaliure("Failed to get list Top Deals Won List"));
  }
}

function* fetchRecentDeals({ payload }) {
  try {
    const response = yield requestRecentClosedDeal(payload);
    yield put(fetchRecentClosedDealsSuccess(response));
  } catch (error) {
    yield put(
      fetchRecentClosedDealsFaliure("Failed to get list Recent Deals Won List")
    );
  }
}

function* fetchleadsPipeline({ payload }) {
  try {
    const response = yield requestleadsPipelineList(payload);
    yield put(fetchleadsPipelineSuccess(response));
  } catch (error) {
    yield put(fetchleadsPipelineFailure("Failed to get list Leads Pipeline"));
  }
}

function* fetchsmartProposalPipeline({ payload }) {
  try {
    const response = yield requestsmartproposalPipelineList(payload);
    yield put(fetchsmartproposalPipelineSuccess(response));
  } catch (error) {
    yield put(
      fetchsmartproposalPipelineFailure(
        "Failed to get list smart proposal pipeline"
      )
    );
  }
}

function* fetchWinList({ payload }) {
  try {
    const response = yield requestwinRate(payload);
    yield put(fetchWinRateSuccess(response));
  } catch (error) {
    yield put(fetchWinRateFaliure("Failed to get list of Win Rate"));
  }
}
function* fetchWinLossList({ payload }) {
  try {
    const response = yield requestwinLossReport(payload);
    yield put(fetchWinLossSuccess(response));
  } catch (error) {
    yield put(fetchWinLossFaliure("Failed to get list of Win Loss"));
  }
}

function* fetchTotalAgreements({ payload }) {
  try {
    const response = yield requestTotalAgreements(payload);
    yield put(fetchtotalAgreementsSuccess(response));
  } catch (error) {
    yield put(fetchtotalAgreementsFailure("Failed to get Total Agreements"));
  }
}

function* fetchClientSeatsKpis({ payload }) {
  try {
    const response = yield requestClientSeatsKPIS(payload);
    yield put(fetchClientSeatsKpisSuccess(response));
  } catch (error) {
    yield put(
      fetchClientSeatsKpisFailure("Failed to get KPIS of client and seats")
    );
  }
}
